/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Packaging_Material_Sale_Price_HintInputs */

const vi_packaging_material_sale_price_hint = /** @type {(inputs: Packaging_Material_Sale_Price_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giá bán vật tư tính vào đơn (không chiết khấu). Để 0 nếu không tính tiền.`)
};

/**

* @param {Packaging_Material_Sale_Price_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const packaging_material_sale_price_hint = /** @type {((inputs?: Packaging_Material_Sale_Price_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Packaging_Material_Sale_Price_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_packaging_material_sale_price_hint(inputs)
});